import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "ed_admin_token";
const SITE_TOKEN_KEY = "ed_site_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const getSiteToken = () => localStorage.getItem(SITE_TOKEN_KEY);
export const setSiteToken = (t) => localStorage.setItem(SITE_TOKEN_KEY, t);
export const clearSiteToken = () => localStorage.removeItem(SITE_TOKEN_KEY);

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    // Prefer admin token (also satisfies the visitor gate), fall back to site token.
    const t = getToken() || getSiteToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export const imageUrl = (filename) => {
    const t = getToken() || getSiteToken();
    const qs = t ? `?token=${encodeURIComponent(t)}` : "";
    return `${API_BASE}/images/${filename}${qs}`;
};
